import { Location } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { UrlHelperService } from '../../core';
import { CATALOG_CONFIG, CatalogConfig } from '../config/catalog.config';
import { CategoryFacetedSearchState, CategoryFacetedSearchStore } from '../store/category-faceted-search.store';
import { PageViewFilterAbstract } from './abstract/page-view-filter.abstract';

/**
 * Handles page view related tasks
 * E.g. page size, sort, view mode, etc.
 */
@Injectable()
export class CategoryPageViewFilterService extends PageViewFilterAbstract<CategoryFacetedSearchStore, CategoryFacetedSearchState> {
  constructor(
    store: CategoryFacetedSearchStore,
    location: Location,
    urlHelper: UrlHelperService,
    @Inject(CATALOG_CONFIG) private catalogConfig: CatalogConfig,
  ) {
    super(store, location, urlHelper);
  }

  /**
   * Reset the store values by checking the url params
   */
  public override resetByUrlParams() {
    super.resetByUrlParams({ ...this.catalogConfig, ...this.defaults });
  }
}
